import { render, staticRenderFns } from "./AddOtherActivities.vue?vue&type=template&id=3ee5988f&scoped=true&"
import script from "./AddOtherActivities.vue?vue&type=script&lang=js&"
export * from "./AddOtherActivities.vue?vue&type=script&lang=js&"
import style0 from "./AddOtherActivities.vue?vue&type=style&index=0&id=3ee5988f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee5988f",
  null
  
)

export default component.exports